import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const RefreshIcon = (props: IconProps) => {
  return (
    <Icon fill="none" viewBox="0 0 21 20" {...props}>
      <path
        d="m18.3 4.7.4-1.4a1 1 0 0 1 2 .6l-1.2 3.8a1 1 0 0 1-1.3.7l-3.8-1.2a1 1 0 1 1 .6-1.9l1.7.5a7.4 7.4 0 0 0-13 1.3l-.3.6A1 1 0 1 1 1.6 7l.2-.7a9.4 9.4 0 0 1 16.5-1.6ZM2.8 15.3l-.3 1.3a1 1 0 1 1-2-.5l1-3.8a1 1 0 0 1 1.3-.8l3.8 1a1 1 0 0 1-.5 2L4.3 14a7.4 7.4 0 0 0 13.2-1.8 1 1 0 1 1 2 .6 9.4 9.4 0 0 1-16.7 2.5Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default RefreshIcon;
